import { call, put, select, takeEvery } from 'redux-saga/effects';
import ImagePreloader from 'image-preloader';

import request from 'helpers/api';

import { setAll } from 'redux/reducers/books';

import { getCurrentBook } from 'redux/selectors/books';
import { SET_ACTIVE_ORDER } from '../reducers/app';
import { delay } from 'redux-saga'

export function* preloadBookImages({ id }) {
  try {
    let existingBook = yield select(getCurrentBook);
    if (!id || !existingBook) {
      return;
    }

    // Preload images
    setTimeout(() => {
      const images = [];
      existingBook.get('spreads', []).forEach(spread => {
        spread.get('inspiration', []).forEach(inspiration => {
          if (images.indexOf(inspiration.getIn(['image', 'url'])) === -1) {
            images.push(inspiration.getIn(['image', 'url']));
          }
        });
      });

      const preloader = new ImagePreloader();
      preloader.preload(...images).then(() => {
        p('Preloaded book images!', id);
      });
    }, 2000);
  } catch (e) {
    pe(e, 'failed preloadBookImages')
  }
}

export function* getBooks() {
  try {
    // Get all books
    const books = yield call(request, 'books/get/all');
    yield put(setAll(books));

    return yield select(state => state.get('books'));
  } catch (e) {
    pe(e, 'failed getBooks')
    return currentBooks
  }
}

export default function* saga() {
  yield takeEvery(SET_ACTIVE_ORDER, preloadBookImages);
}



// WEBPACK FOOTER //
// ./app/redux/sagas/books.js